module.exports = __webpack_public_path__ + "static/RooferOnSlant-96ba28224a441526be9211d321fe4e4c.jpg";